import api from 'api/axiosInstance';
import { FacetEditShadingStatus, normalizeFacetShadingStatus } from 'api/editDsm';
import { getToken, createApiUrl } from '../../../util';


async function changePanelAndRetianLayout(uuid: string, panelKey: string): Promise<FacetEditShadingStatus | undefined> {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const apiUrl = '/designs/retain-layout';
	const body = {
		uuid,
		panelKey
	};
	const { data } = await api.post(createApiUrl(apiUrl), body, config);

	return normalizeFacetShadingStatus(data);
}

type AddPanelLayoutPayload = {
	uuid: string;
	panelKey: string;
	resetPanelKey?: boolean;
}

async function addPanelLayout(payload: AddPanelLayoutPayload): Promise<FacetEditShadingStatus | undefined> {
	const token = getToken('Authorization');
	const config = {
		headers: {
			'Authorization': `Bearer ${token}`
		}
	};

	const body = {
		uuid: payload.uuid,
		panelKey: payload.panelKey,
		resetPanelKey: payload?.resetPanelKey ?? false,
	};

	const apiUrl = '/designs/add-panel-layout';
	const { data } = await api.post(createApiUrl(apiUrl), body, config);

	return normalizeFacetShadingStatus(data);
}

export {
	changePanelAndRetianLayout,
	addPanelLayout
};
